var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('cancel-heading',{attrs:{"is-centered":""}},[_vm._v("Your On the Way")]),_vm._v(" "),_c('cancel-content',{attrs:{"is-centered":""}},[_vm._v("Learn how to turn leads into deals with Forefront.")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }